"use client";
import React from "react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const DOTS_CONFIG = [
  // Area superiore sinistra
  {
    color: "bg-[#f7b325]/100",
    shadowColor: "#f7b325",
    size: "w-4 h-4",
    x: "12%",
    y: "18%",
  },
  {
    color: "bg-[#33a5e1]/100",
    shadowColor: "#33a5e1",
    size: "w-3 h-3",
    x: "8%",
    y: "25%",
  },
  {
    color: "bg-[#f05822]/100",
    shadowColor: "#f05822",
    size: "w-5 h-5",
    x: "18%",
    y: "22%",
  },

  // Area superiore destra
  {
    color: "bg-[#f7b325]/100",
    shadowColor: "#f7b325",
    size: "w-4 h-4",
    x: "88%",
    y: "15%",
  },
  {
    color: "bg-[#f05822]/100",
    shadowColor: "#f05822",
    size: "w-3 h-3",
    x: "85%",
    y: "28%",
  },
  {
    color: "bg-[#33a5e1]/100",
    shadowColor: "#33a5e1",
    size: "w-4 h-4",
    x: "92%",
    y: "35%",
  },

  // Area inferiore sinistra
  {
    color: "bg-[#f05822]/100",
    shadowColor: "#f05822",
    size: "w-4 h-4",
    x: "15%",
    y: "75%",
  },
  {
    color: "bg-[#33a5e1]/100",
    shadowColor: "#33a5e1",
    size: "w-3 h-3",
    x: "22%",
    y: "78%",
  },
  {
    color: "bg-[#f7b325]/100",
    shadowColor: "#f7b325",
    size: "w-5 h-5",
    x: "10%",
    y: "82%",
  },

  // Area inferiore destra
  {
    color: "bg-[#33a5e1]/100",
    shadowColor: "#33a5e1",
    size: "w-4 h-4",
    x: "85%",
    y: "72%",
  },
  {
    color: "bg-[#f05822]/100",
    shadowColor: "#f05822",
    size: "w-3 h-3",
    x: "90%",
    y: "78%",
  },
  {
    color: "bg-[#f7b325]/100",
    shadowColor: "#f7b325",
    size: "w-4 h-4",
    x: "88%",
    y: "85%",
  },
];
const MOBILE_DOTS_COUNT = 5;

export const AnimatedDots = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const mediaQuery = window.matchMedia("(max-width: 768px)");
      setIsMobile(mediaQuery.matches);
      const handler = (e: MediaQueryListEvent) => {
        setIsMobile(e.matches);
      };
      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    }
  }, []);

  const dotsToRender = isMobile
    ? DOTS_CONFIG.slice(0, MOBILE_DOTS_COUNT)
    : DOTS_CONFIG;

  return (
    <>
      {dotsToRender.map((dot, index) => (
        <motion.div
          key={`dot-${index}`}
          className={`absolute rounded-full ${dot.color} ${dot.size} z-0 will-change-transform`}
          style={{
            left: dot.x,
            top: dot.y,
            boxShadow: `0 0 12px ${dot.color.replace("/100", "/60")}`,
            transform: "translate(0, 0)", //debug override
          }}
          initial={{ opacity: 0.6, scale: 0.8 }}
          animate={{
            opacity: [0.5, 1, 0.6],
            scale: [1, 1.2, 1],
            y: [0, -15, 0],
            x: [0, (index % 2 ? 1 : -1) * 8, 0],
          }}
          transition={{
            duration: 3 + Math.random() * 2,
            delay: index * 0.2,
            repeat: Infinity,
            repeatType: "mirror",
            ease: [0.5, 0, 0.5, 1],
          }}
        />
      ))}
    </>
  );
};
export default AnimatedDots;
